import { SpinnerBase, SpinnerFullscreenBase } from './Spinner.style';

export interface SpinnerProps {
    color?: string;
    width?: number;
    size?: number;
}

export const Spinner = ({
    size = 36,
    color = 'currentColor',
}: SpinnerProps): JSX.Element => (
    <SpinnerBase width={size} height={size} viewBox="0 0 50 50">
        <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth={Math.max(1, size / 10)}
            stroke={color}
        />
    </SpinnerBase>
);

export const SpinnerFullscreen = ({
    size = 36,
    color = 'currentColor',
}: SpinnerProps) => (
    <SpinnerFullscreenBase width={size} height={size} viewBox="0 0 50 50">
        <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth={Math.max(1, size / 10)}
            stroke={color}
        />
    </SpinnerFullscreenBase>
);
